"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GleamCouponToJSON = exports.GleamCouponFromJSONTyped = exports.GleamCouponFromJSON = void 0;
function GleamCouponFromJSON(json) {
    return GleamCouponFromJSONTyped(json, false);
}
exports.GleamCouponFromJSON = GleamCouponFromJSON;
function GleamCouponFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'code': json['code'],
    };
}
exports.GleamCouponFromJSONTyped = GleamCouponFromJSONTyped;
function GleamCouponToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'code': value.code,
    };
}
exports.GleamCouponToJSON = GleamCouponToJSON;
